/**
 * Normalises page paths for APM transaction grouping.
 * Replaces dynamic segments with '$' placeholder where needed.
 */
export const normalisePagePath = (urlPath: string): string => {
  // Competitions form pages have dynamic IDs
  if (urlPath.startsWith('/ecom/content/competitions/')) {
    return '/ecom/content/competitions/$';
  }

  return urlPath;
};

/**
 * Normalises API paths for APM transaction grouping.
 * Replaces dynamic segments (competition IDs, types) with '$' placeholder.
 *
 * @example
 * 'POST /api/competitions-prod/v1/competitions/summer-2024/competitiontypes/prize-draw/entries'
 * → 'POST /api/competitions-prod/v1/competitions/$/competitiontypes/$/entries'
 */
export const normaliseApiPath = (urlPath: string): string => {
  // Normalise competitions API paths
  // Pattern: competitions/{id}/competitiontypes/{type}/entries
  if (urlPath.includes('/competitions/') && urlPath.includes('/competitiontypes/')) {
    return urlPath.replace(
      /\/competitions\/[^/]+\/competitiontypes\/[^/]+\//,
      '/competitions/$/competitiontypes/$/',
    );
  }

  return urlPath;
};
